import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import useBlock from "../../services/Order/useBlock";
import { GlobalContext } from "../../Context/GlobalContext";
import LoadingScreen from "../../utils/LoadingScreen";
import { Lock, RefreshCcw } from "lucide-react";
import { formatDateTime } from "../../utils/dateFormatter";

const BlockUser = () => {
  const { userID } = useContext(GlobalContext);

  const { blockedUsers, fetchBlockedUsers, blockUser, unblockUser, loading } =
    useBlock();

  const [showModal, setShowModal] = useState(false);
  const [person, setPerson] = useState("");
  const [mobile, setMobile] = useState("");

  useEffect(() => {
    fetchBlockedUsers(userID);
  }, [userID]);

  /* Block User */

  const handleBlock = async () => {
    if (!mobile) {
      toast.error("Please enter mobile number");
      return;
    }

    const success = await blockUser(userID, mobile, person);

    if (success) {
      toast.success("User blocked successfully");

      setMobile("");
      setPerson("");
      setShowModal(false);

      fetchBlockedUsers(userID);
    }
  };

  
  /* Unblock */

  const handleUnblock = async (mobile) => {
    const success = await unblockUser(userID, mobile);

    if (success) {
      toast.success("User unblocked successfully");

      setTimeout(() => {
        fetchBlockedUsers();
      }, 300);
    } else {
    }
  };

  return (
    <>
      <div className="p-6 min-h-0 h-full flex flex-col overflow-hidden montserrat-font-1">
        {/* Header */}

        <div className="flex justify-between items-center mb-5 montserrat-font-1">
          <h1 className="text-xl font-semibold text-gray-800">Block Users</h1>

          <div className="flex gap-2">
            <button
              onClick={() => fetchBlockedUsers(userID)}
              className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-blue-700 flex items-center gap-2"
            >
              <RefreshCcw size={14} />
              Refresh
            </button>

            <button
              onClick={() => setShowModal(true)}
              className="bg-green-600 text-white px-4 py-2 rounded-lg text-sm hover:bg-green-700 flex items-center gap-2"
            >
              <Lock size={14} /> Block Another
            </button>
          </div>
        </div>

        {/* Table */}

        <div className="border rounded-xl overflow-auto h-full montserrat-font-1">
          <table className="w-full text-sm bg-white montserrat-font-1">
            <thead className="sticky top-0 z-10 bg-green-100 text-gray-600 montserrat-font-1">
              <tr>
                <th className="p-3 text-left">S.No</th>
                <th className="p-3 text-left">Name</th>
                <th className="p-3 text-left">Mobile</th>
                <th className="p-3 text-left">Created On</th>
                <th className="p-3 text-left">Action</th>
              </tr>
            </thead>

            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10" className="text-center py-10">
                    <LoadingScreen text="Loading data..." />
                  </td>
                </tr>
              ) : blockedUsers.length === 0 ? (
                <tr>
                  <td colSpan="10" className="text-center py-6 text-gray-500">
                    No Records Found
                  </td>
                </tr>
              ) : (
                blockedUsers.map((item, index) => (
                  <tr key={index} className="border-t hover:bg-gray-50">
                    <td className="p-3">{index + 1}</td>

                    <td className="p-3">{item.name || "N/A"}</td>

                    <td className="p-3">{item.mobile}</td>

                    <td className="p-3">{formatDateTime(item.created_on, true)}</td>

                    <td className="p-3">
                      <button
                        onClick={() => handleUnblock(item.mobile)}
                        className="text-red-600 border border-red-500 px-3 py-1 rounded-lg text-xs hover:bg-red-50"
                      >
                        Unblock
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Modal */}

        {showModal && (
          <div className="fixed inset-0 bg-black/40 flex justify-center montserrat-font-1 items-center z-50">
            <div className="bg-white w-[400px] rounded-xl shadow-lg montserrat-font-1 ">
              {/* Header */}

              <div className="flex justify-between items-center px-5 py-4 border-b">
                <h2 className="text-sm font-semibold">Enter Block Number</h2>

                <button
                  onClick={() => setShowModal(false)}
                  className="text-gray-500 hover:text-gray-700"
                >
                  ✕
                </button>
              </div>

              {/* Body */}

              <div className="p-5 space-y-4">
                <div>
                  <label className="text-xs font-medium text-gray-600">
                    Name
                  </label>

                  <input
                    type="text"
                    value={person}
                    onChange={(e) => setPerson(e.target.value)}
                    placeholder="Enter name"
                    className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                  />
                </div>

                <div>
                  <label className="text-xs font-medium text-gray-600">
                    Mobile Number
                  </label>

                  <input
                    type="text"
                    value={mobile}
                    onChange={(e) => setMobile(e.target.value)}
                    placeholder="Enter mobile"
                    className="mt-1 w-full border rounded-lg px-3 py-2 text-sm"
                  />
                </div>
              </div>

              {/* Footer */}

              <div className="flex justify-end gap-3 px-5 py-4 border-t">
                <button
                  onClick={() => setShowModal(false)}
                  className="px-4 py-2 border rounded-lg text-sm bg-gray-100"
                >
                  Cancel
                </button>

                <button
                  onClick={handleBlock}
                  className="px-4 py-2 bg-green-600 text-white rounded-lg text-sm hover:bg-green-700"
                >
                  Block Person
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BlockUser;
